<div class="video-ad" #container [class.visible]="visible && !core.adsDisabled">
  <div class="floater" [class.floating]="float && !closed">
    <div class="close" (click)="close()">X</div>
    <div [id]="ad" ></div>
  </div>
</div>
